import { createFileRoute } from '@tanstack/react-router';
import TurnReportList from '~/containers/TurnReportList';

export const Route = createFileRoute('/turn-reports/')({
  component: TurnReportList,
  validateSearch(search) {
    return {
      tab: (search.tab as string) || undefined,
      page: search.page !== undefined ? Number(search.page) : undefined,
      perPage:
        search.perPage !== undefined ? Number(search.perPage) : undefined,
    };
  },
});
